import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const HighlightsawardsSection = () => {
  const [data, setData] = useState([]);
  const [partners, setPartners] = useState([]);

  const fetchPartners = async () => {
    try {
      const response = await corefetch("HighlightsAwards/GetAwards");
      if (response) {
        setPartners(response);
      } else {
        setPartners([]);
        console.error("Failed to fetch partners data");
      }
    } catch (error) {
      setPartners([]);
      console.error("Error fetching list:", error);
    }
  };
  const fetchHighlights = async () => {
    try {
      const response = await corefetch("HighlightsAwards/GetHighlights");
      if (response) {
        setData(response);
      } else {
        setData([]);
        console.error("Failed to fetch highlights data");
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchHighlights();
    fetchPartners();
  }, []);

  useEffect(() => {
    if (data?.length) {
      setTimeout(() => {
        $(".highlight-slider").owlCarousel({
          autoplay: true,
          smartSpeed: 300,
          margin: 0.5,
          loop: true,
          lazyLoad: true,
          autoplayHoverPause: true,
          dots: false,
          arrows: false,
          nav: false,
          center: true,
          autoWidth: false,
          autoHeight: true,
          items: 5,
          navText: [
            '<i class="ti-arrow-left"></i>',
            '<i class="ti-arrow-right"></i>',
          ],
          responsive: {
            0: {
              items: 1,
              dots: false,
              arrows: false,
              nav: false,
            },

            575: {
              items: 1,
            },
            767: {
              items: 1,
              dots: false,
            },

            992: {
              items: 5,
              dots: false,
            },

            1200: {
              items: 5,
            },
          },
        });
        document.querySelectorAll(".odometer").forEach((el) => {
          const count = el.getAttribute("data-count");
          el.innerHTML = count;
        });
      }, 100);
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (partners?.length) {
      $(".partners-slider").owlCarousel({
        autoplay: true,
        smartSpeed: 300,
        margin: 0,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        arrows: false,
        nav: false,
        responsive: {
          0: {
            items: 2,
          },

          550: {
            items: 3,
          },

          992: {
            items: 4,
          },

          1200: {
            items: 5,
          },
        },
      });
    }
  }, [JSON.stringify(partners)]);

  return (
    <>
      {partners != null && partners.length > 0 && (
        <section className="wpo-partners-section section-padding">
          <div className="container">
            <div className="row">
              <div className="col col-xs-12">
                <div className="partner-grids partners-slider owl-carousel">
                  {partners?.map((partner) => (
                    <div key={partner.awardsID} className="grid">
                      <img
                        src={`${ImageURL}${partner.imagePath}`}
                        alt={`Partner ${partner.id}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default HighlightsawardsSection;
